import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Card, Col, Container, Row, Table } from "reactstrap";
import { InvoiceButtons } from "../Common/InvoiceButtons";
import { InvoiceAddressSection } from "./InvoiceAddressSection";
import { InvoiceDateSection } from "./InvoiceDateSection";
import { InvoiceHeadSection } from "./InvoiceHeadSection";
import { InvoiceTable } from "./InvoiceTable";
import { InvoiceTexSection } from "./InvoiceTexSection";

const Invoice2Container = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({ contentRef });
  return (
    <>
      <Container className="invoice-2">
        <div ref={contentRef}>
          <Row>
            <Col sm="12">
              <Card className="p-4">
                <Table borderless>
                  <tbody>
                    <tr><InvoiceHeadSection /></tr>
                    <tr><InvoiceDateSection /></tr>
                    <tr><InvoiceAddressSection /></tr>
                    <tr>
                      <td className="p-0">
                        <InvoiceTable />
                      </td>
                    </tr>
                    <tr><InvoiceTexSection /></tr>
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
      <InvoiceButtons handlePrint={handlePrint} />
    </>
  );
};

export default Invoice2Container;
